import tw from 'tailwind.macro';

export const PageContainer = tw.div`px-5 py-8 mx-auto`;

export const AllProjectsContainer = tw.div`lg:w-2/3 flex mb-8 mt-2 flex-col sm:flex-row sm:items-center items-start mx-auto`;

export const ProjectCardContainer = tw.div`w-full`;
